import { FaDownload, FaFileExcel } from "react-icons/fa";
import { ExportExcelContainer } from "./style";

interface IExportExcel {
  onClick?: () => void;
  variant?: "primary" | "secondary";
  textoBotao?: string;
  iconeDownload?: "download" | "excel";
  width?: number;
}

function ExportExcel({
  onClick,
  textoBotao = "Exportar",
  variant = "primary",
  iconeDownload = "download",
  width = 120,
}: IExportExcel) {
  const iconeStrategy = {
    download: <FaDownload />,
    excel: <FaFileExcel />,
  };
  return (
    <ExportExcelContainer variant={variant} onClick={onClick} width={width}>
      {textoBotao}
      {iconeStrategy[iconeDownload]}
    </ExportExcelContainer>
  );
}
export { ExportExcel };
